import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const SignOutPage = React.lazy(() => import('modules/core/pages/session/SignOutPage'))

export const sessionRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.logout.path,
      element: (
        <React.Suspense>
          <SignOutPage />
        </React.Suspense>
      ),
    },
  ]
}
